'use client';

import React, { useState } from 'react';
import { X } from 'lucide-react';

const MOODS = [
  { emoji: '😊', label: 'Good' },
  { emoji: '😌', label: 'Calm' },
  { emoji: '😔', label: 'Low' },
  { emoji: '😰', label: 'Anxious' },
  { emoji: '😤', label: 'Frustrated' },
  { emoji: '😶', label: 'Numb' },
  { emoji: '🥹', label: 'Overwhelmed' },
  { emoji: '💪', label: 'Motivated' },
];

interface Props {
  onSelect: (mood: string) => void;
  onDismiss: () => void;
}

export default function MoodCheckIn({ onSelect, onDismiss }: Props) {
  const [selected, setSelected] = useState<string | null>(null);

  const handleSelect = (label: string) => {
    setSelected(label);
    setTimeout(() => {
      onSelect(label);
    }, 300);
  };

  return (
    <div className="px-4 py-4 fade-in">
      <div className="max-w-lg mx-auto bg-card border border-border rounded-3xl p-4 shadow-sm relative">
        <button
          onClick={onDismiss}
          className="absolute top-3 right-3 w-7 h-7 rounded-xl flex items-center justify-center text-muted-foreground hover:bg-muted transition-colors active:scale-90"
          aria-label="Dismiss"
        >
          <X size={14} />
        </button>

        <p className="text-sm font-semibold text-foreground mb-0.5">How are we feeling?</p>
        <p className="text-xs text-muted-foreground mb-3">No pressure — just helps Clingy show up for you better.</p>

        <div className="flex flex-wrap gap-2">
          {MOODS.map(({ emoji, label }) => (
            <button
              key={label}
              onClick={() => handleSelect(label)}
              className={`flex items-center gap-1.5 px-3 py-2 rounded-2xl border text-xs font-medium transition-all duration-200 active:scale-95 ${
                selected === label
                  ? 'border-primary bg-primary/10 text-primary' :'border-border bg-background text-foreground hover:border-primary/50 hover:bg-primary/5'
              }`}
            >
              <span className="text-base leading-none">{emoji}</span>
              <span>{label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
